module.exports = __webpack_public_path__ + "static/media/aicpa-cima-logo-pride.2028af8b.svg";